















































































import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import FoldingCard from '@/components/FoldingCard.vue'
import { Account } from '@/modules/Account/interfaces/account'
import { dateTimeToDisplay } from '@/utils/dateTime'
import { tablePerPageOptions } from '@/utils/tablePerPageOptions'
import { showErrors } from '@/utils/snack'
import { translateQuoteStatusKey } from '@/utils/translate'
import { quoteStatus, quoteStatusClass, quoteType } from '@/modules/Quote/helpers/quote'

import QuoteDialog from '@/modules/Quote/scripts/quote-dialog'
import PolicyDialog from '@/modules/Policy/scripts/policy-dialog'
import { getQuotes } from '@/modules/Quote/gql/quote.gql'
import { Quote } from '@/modules/Quote/interfaces/quote'
import { ApolloResponse } from '@/interfaces/apollo'

@Component({
  components: {
    FoldingCard
  }
})
export default class AccountDetailQuotes extends mixins(QuoteDialog, PolicyDialog) {
  @Prop({ type: Object as () => Account }) readonly account!: Account

  accountId: number | null = null

  quoteStatus = quoteStatus
  quoteStatusClass = quoteStatusClass
  quoteType = quoteType
  translateQuoteStatusKey = (key: string) => translateQuoteStatusKey(key)

  quotes: Quote[] = []

  orderBy: {
    [key: string]: string
  } = {
    name: 'NAME',
    status: 'STATUS',
    id: 'ID'
  }

  tableColumn = [
    { field: 'name',
      title: 'Quote Name',
      slots: { default: 'name_default' },
      sortable: true,
      resizable: true
    },
    { field: 'contactName',
      title: 'Contact Name',
      slots: { default: 'contact_name_default' },
      resizable: true
    },
    { field: 'status', title: 'Quote Status', slots: { default: 'status_default' }, resizable: true, sortable: true, width: 140 },
    { field: 'type', title: 'Quote Type', slots: { default: 'type_default' }, resizable: true, width: 140 },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 100 }
  ]

  tableOptions = {
    loading: false,
    tablePage: tablePerPageOptions(),
    sortBy: 'id',
    sortDesc: true
  }

  @Emit('refresh')
  onSuccess () {
    // do nothing
  }

  dateTimeToDisplay = dateTimeToDisplay

  async mounted () {
    this.getQuotes()
  }

  @Watch('account', { deep: true })
  onAccountUpdated () {
    this.getQuotes()
  }

  async getQuotes () {
    const { sortBy, sortDesc, tablePage } = this.tableOptions
    const { currentPage, pageSize } = tablePage
    const orderBy = this.orderBy[sortBy] || 'ID'
    this.tableOptions.loading = true
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getQuotes,
        variables: {
          filter: {
            accountId: Number(this.account.id)
          },
          order: {
            orderBy: orderBy,
            asc: !sortDesc
          },
          paging: {
            offset: (currentPage - 1) * pageSize,
            limit: pageSize
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.tableOptions.loading = false
      this.quotes = result.data.getQuotes.quotes
      this.tableOptions.tablePage.total = result.data.getQuotes.paging.totalCount
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  routeToDetail (item: any) {
    return {
      name: 'QuoteDetailDetail',
      params: {
        id: item.id
      }
    }
  }

  routeToAccountDetail (item: any) {
    if (item.account) {
      return {
        name: 'AccountDetailDetail',
        params: {
          id: item.account.id
        }
      }
    }
  }

  routeToContactDetail (item: any) {
    if (item.primaryContact) {
      return {
        name: 'ContactDetailDetail',
        params: {
          id: item.primaryContact.id
        }
      }
    }
  }

  sortTable (column: any) {
    this.tableOptions.sortBy = column.property
    this.tableOptions.sortDesc = column.order === 'desc'
    this.getQuotes()
  }

  handlePageChange (pageData: any) {
    this.tableOptions.tablePage.currentPage = pageData.currentPage
    this.tableOptions.tablePage.pageSize = pageData.pageSize
    this.getQuotes()
  }

  async deleteQuoteConfirm () {
    await this.deleteQuotePost()
    this.onSuccess()
  }
}
